// @flow

import * as React from 'react';
import RowActions from 'esm-web-pro/components/layout/sidePanel/RowActions';
import MeatballsIcon from 'esm-web-pro/components/layout/sidePanel/icons/MeatballsIcon';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import { Box, Text } from 'grommet';
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { injectIntl, IntlShape } from 'react-intl';

type Props = {
    object: Object,
    type: string,
    intl: IntlShape,
    text: string,
    rowPad?: Object,
    textPad?: Object,
}


const NotificationTypeContentRow = (props: Props) => {
    const history = useHistory();
    const match = useRouteMatch();

    const {
        object, type, intl: { formatMessage }, text, rowPad, textPad,
    } = props;

    return (
        <ContentRow
            childrenWidth="80%"
            pad={rowPad}
            rowId={`${type}-row${object.id}`}
            actions={(
                <RowActions
                    iconPadding="3px"
                    gapBetweenActions="small"
                    actions={[
                        {
                            key: `${object.id}-more`,
                            icon: <MeatballsIcon />,
                            size: '20px',
                            width: '3px',
                            callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                                e.stopPropagation();
                                const path = match.url.split('/notifications');
                                history.push(`${path[0]}/notifications/${type}s/update/${object.id}`);
                            },
                            tooltip: formatMessage(actionMessages.more),
                        },
                    ]}
                />
            )}
        >
            <Box pad={textPad}>
                <Text>
                    {text}
                </Text>
            </Box>
        </ContentRow>
    );
};

NotificationTypeContentRow.defaultProps = {
    rowPad: { horizontal: 'small' },
    textPad: { left: 'xsmall', right: 'small' },
};

export default injectIntl(NotificationTypeContentRow);
